import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import "./VMA_main.css";
import BannerComponent from "../../components/bannerComponent/bannerComponent";
import BenefitsCardsComponent from "../../components/benefitsCardsComponent/benefitsCardsComponent";
import ButtonLinkComponent from "../../components/buttonLink/buttonLink";

const VMAComponent = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=VMA";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("ENHANCE_PRACTICE_TITLE"),
    title2: t("ENHANCE_PRACTICE_TITLE2"),
    text: t("ENHANCE_PRACTICE_DESC"),
    className: "vmaHeroBanner",
    chipText: t("VMA_HERO_CHIP"),
  };

  const cardBenefitsData = [
    {
      title: t("TIME_MANAGEMENT"),
      text: t("TIME_MANAGEMENT_DESC"),
      img: "/img/hourglass-dollar-depict-time-money 1.jpg",
    },
    {
      title: t("COST_SAVINGS"),
      text: t("COST_SAVINGS_DESC"),
      img: "/img/piggy-bank-s-overflow-coins-illustrates-savings-financial-learning 1.jpg",
    },
    {
      title: t("IMPROVED_ORGANIZATION"),
      text: t("IMPROVED_ORGANIZATION_DESC"),
      img: "/img/young-businesswoman-brainstorming-sticky-note-ideas-night-generated-by-ai 1.jpg",
    },
  ];

  const services = [
    {
      title: t("APPOINTMENT_SCHEDULING"),
      icon: "calendarWhite.svg",
      text: t("APPOINTMENT_SCHEDULING_DESC"),
    },
    {
      title: t("ADMINISTRATIVE_SUPPORT"),
      icon: "supportWhite.svg",
      text: t("ADMINISTRATIVE_SUPPORT_DESC"),
    },
    {
      title: t("COMMUNICATION_MANAGEMENT"),
      icon: "communicationWhite.svg",
      text: t("COMMUNICATION_MANAGEMENT_DESC"),
    },
  ];

  const vmaServices = [
    {
      title: t("BROWSE_SERVICE_CATALOG"),
      route: "/vma/specialist",
      text: t("BROWSE_SERVICE_CATALOG_DESC"),
      buttonText: t("EXPLORE_SERVICES"),
      img: "/img/front-view-nurses-team-hospital 1.jpg",
    },
    {
      title: t("IMPULSE_CAREER"),
      route: "/vma/gethired",
      text: t("IMPULSE_CAREER_DESC"),
      buttonText: t("APPLY_NOW"),
      img: "/img/nurse-portrait-hospital 1.jpg",
    },
  ];

  function VmaExploreCard({ img, title, text, route, buttonText }) {
    return (
      <article className="vmaExploreCard">
        <div className="vmaExploreMedia">
          <img src={img} alt={title} />
        </div>

        <div className="vmaExploreContent">
          <h3>{title}</h3>
          <p>{text}</p>

          <ButtonLinkComponent
            translateButton={buttonText}
            url={route}
          />
        </div>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="vmaPage">
        <section className="vmaHero vmaHeroFull">
          <div className="vmaHeroBannerFull">
            <BannerComponent
              translateTitle={`${heroData.title} ${heroData.title2}`}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("HIRE_VMA")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="vmaBenefits">
          <div className="vmaBenefitsWrap">
            <div className="vmaSectionIntro">
              <h2>{t("DISCOVER_BENEFITS")}</h2>
              <p>{t("STREAMLINE_TASKS")}</p>
            </div>

            <div className="vmaBenefitsGrid">
              {cardBenefitsData.map((data, index) => (
                <article className="vmaBenefitCard" key={index}>
                  <div className="vmaBenefitMedia">
                    <img src={data.img} alt={data.title} />
                  </div>
                  <div className="vmaBenefitContent">
                    <h3>{data.title}</h3>
                    <p>{data.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="vmaKeyServices">
          <BenefitsCardsComponent
            title={t("KEY_SERVICES_OFFERED")}
            cardsData={services}
          />
        </section>

        <section className="vmaExplore">
          <div className="vmaExploreGrid">
            {vmaServices.map((data, index) => (
              <VmaExploreCard
                key={index}
                title={data.title}
                text={data.text}
                img={data.img}
                route={data.route}
                buttonText={data.buttonText}
              />
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default VMAComponent;